// SearchTag.tsx
import React from 'react';

import { CloseIcon } from '@/assets/icon/CloseIcon';

import PlainIconButton from '../PlainIconButton/PlainIconButton';
import {
  ClearIconButton,
  SearchTag,
  SearchTagContent,
} from './SearchTag.style';

interface TagProps {
  label: string;
  onClick?: () => void;
  onClear?: (e: React.MouseEvent) => void;
  showClearIcon?: boolean;
}

const Tag: React.FC<TagProps> = ({
  label,
  onClick,
  onClear,
  showClearIcon = false,
}) => {
  const handleClearClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClear?.(e);
  };

  return (
    <SearchTag onClick={() => onClick?.()}>
      <SearchTagContent variant="caption">{label}</SearchTagContent>
      {showClearIcon && onClear && (
        <PlainIconButton
          aria-label="remove-history"
          onClick={handleClearClick}
          style={{
            ...ClearIconButton,
          }}
        >
          <CloseIcon height={10} width={10} />
        </PlainIconButton>
      )}
    </SearchTag>
  );
};

export default Tag;
